import { B400, N40 } from '@atlaskit/theme/colors';
var getIconColors = function getIconColors(isSelected) {
  if (isSelected) {
    return {
      primary: "var(--ds-background-brand-bold, ".concat(B400, ")"),
      secondary: "var(--ds-icon-inverse, ".concat(N40, ")")
    };
  }
  return {
    primary: "var(--ds-background-neutral, ".concat(N40, ")"),
    secondary: "var(--ds-UNSAFE-transparent, ".concat(N40, ")")
  };
};
export default getIconColors;